<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Kontakt</h4>
    </div>
  </div>
  <mat-card>
    <p>
      Weitere Informationen zur Literaturdatenbank Tierwohlindikatoren erhalten
      Sie bei:
    </p>
    <h4>
      <p>
        <b>Allgemeine Informationen zur Datenbank: </b>
      </p>
    </h4>

    <h5>
      <b>Kuratorium für Technik und Bauwesen in der Landwirtschaft e.V.</b>
    </h5>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        Bartningstraße 49
        <br />
        64289 Darmstadt <br />
        Tel.: +49 6151 7001-0 <br />
        E-Mail:
        <a
          href="mailto:ktbl@ktbl.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >ktbl@ktbl.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_KTBL.png"
          alt="ktbl"
          class="img"
          height="80px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    Dr. Ute Schultheiß
    <br />
    E-Mail:
    <a
      href="mailto:kundenservice@ktbl.de.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
      >kundenservice@ktbl.de</a
    >
    <br />
    <br />
    <h4>
      <p>
        <b>Informationen zu den Indikator-Steckbriefen: </b>
      </p>
    </h4>

    <h5><b>Aquakultur:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.thuenen.de/de/fi/personal/wissenschaftliches-personal/dr-vincent-lugert/"
          target="_blank"
          >Dr. Vincent Lugert</a
        >
        <br />
        Thünen-Institut für Fischereiökologie, Bremerhaven
        <br />E-Mail:
        <a
          href="mailto:vincent.lugert@thuenen.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >vincent.lugert@thuenen.de</a
        >
        <br />
        <br />
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.tiho-hannover.de/kliniken-institute/fachgebiete/abteilung-fischkrankheiten-und-fischhaltung/unser-team/dr-karina-retter"
          target="_blank"
          >Dr. Karina Retter</a
        >
        <br />
        Tierärztliche Hochschule Hannover
        <br />E-Mail:
        <a
          href="mailto:Karina.retter@tiho-hannover.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >Karina.retter@tiho-hannover.de</a
        >
        <br />
        <br />
        <a
          href="https://www.tiho-hannover.de/kliniken-institute/fachgebiete/abteilung-fischkrankheiten-und-fischhaltung/unser-team/felix-teitge"
          target="_blank"
          >Felix Teitge</a
        >
        <br />
        Tierärztliche Hochschule Hannover
        <br />E-Mail:
        <a
          href="mailto:Felix.teitge@tiho-hannover.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >Felix.teitge@tiho-hannover.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Tieraerztliche_HS_Hannover.png"
          alt="Tieraerztliche_HS_Hannover"
          class="img"
          height="152.89px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Geflügel:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.hs-osnabrueck.de/personensuche/az-item/redantz-anke/"
          target="_blank"
          >Dr. Anke Redantz</a
        >

        <br />
        Hochschule Osnabrück
        <br />E-Mail:
        <a
          href="mailto:a.redantz@hs-osnabrueck.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >a.redantz@hs-osnabrueck.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_HS_Osnabrueck.png"
          alt="HS-Osnabrueck"
          class="img"
          height="104.89px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Rind:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a href="https://www.thuenen.de/index.php?id=8735&L=0" target="_blank"
          >Dr. Dörte Frieten</a
        >
        <br />

        Thünen-Institut für Ökologischen Landbau, Trenthorst
        <br />E-Mail:
        <a
          href="mailto:doerte.frieten@thuenen.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >doerte.frieten@thuenen.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Schaf und Ziege:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.agrar.hu-berlin.de/de/institut/departments/dntw/tierhaltung/mitarb/mitarb-haupt"
          target="_blank"
          >Marlen Bielicke</a
        >
        <br />

        Humboldt-Universität zu Berlin
        <br />E-Mail:
        <a
          href="mailto:marlen.bielicke.1@hu-berlin.de ?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >marlen.bielicke.1@hu-berlin.de
        </a>
        <br />
        <br />
        <a
          href="https://www.agrar.hu-berlin.de/de/institut/departments/dntw/tierhaltung/mitarb/mitarb-haupt"
          target="_blank"
          target="_blank"
          >Christel Simantke</a
        >
        <br />
        Humboldt-Universität zu Berlin
        <br />E-Mail:
        <a
          href="mailto:christel.simantke@hu-berlin.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >christel.simantke@hu-berlin.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_HU_Berlin.png"
          alt="Humboldt Universität zu Berlin"
          class="img"
          height="152.89px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Schwein:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.tierzucht.uni-kiel.de/de/team/tierhaltung-produktqualitaet/wiss.-mitarbeiterinnen-mitarbeiter/krugmann"
          target="_blank"
          >Dr. Katja Krugmann</a
        >
        <br />
        Christian-Albrechts-Universität zu Kiel
        <br />E-Mail:
        <a
          href="mailto:kkrugmann@tierzucht.uni-kiel.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >kkrugmann@tierzucht.uni-kiel.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_CAU.png"
          alt="CAU"
          class="img"
          height="109.34px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Statistisches Bundesamt:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.destatis.de/DE/Home/_inhalt.html;jsessio-nid=F93D7ADB27AF6AB433712B92B4DE6B1F.internet721"
          target="_blank"
          >Nina Heil</a
        >
        <br />
        Statistisches Bundesamt, Bonn
        <br />E-Mail:
        <a
          href="mailto:Nina.Heil@destatis.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >Nina.Heil@destatis.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Statistisches_Bundesamt.png"
          alt="Statistisches_Bundesamt"
          class="img"
          height="78.23px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Tierwohl-Begleitindikatoren:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.thuenen.de/de/bw/personal/wissenschaftliches-personal/dr-julia-johns"
          target="_blank"
          >Dr. Julia Johns</a
        >

        <br />
        Thünen-Institut für Betriebswirtschaft, Braunschweig
        <br />E-Mail:
        <a
          href="mailto:julia.johns@thuenen.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >julia.johns@thuenen.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_Thuenen_Institut.png"
          alt="Thuenen_Institut"
          class="img"
          height="85px"
          style="float: left"
        />
      </div>
    </div>

    <br />
    <h5><b>Transport und Schlachtung Rind, Schwein, Geflügel:</b></h5>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">
        <a
          href="https://www.fli.de/de/institute/institut-fuer-tierschutz-und-tierhaltung-itt/forschungsbereiche-arbeitsgruppen/fb-transport/forschungsprojekte-einzelansicht/forschungsprojekt-nationales-tierwohl-monitoring-natimon/"
          target="_blank"
          >Dr. Isa Kernberger-Fischer</a
        >
        <br />
        Friedrich-Loeffler-Institut, Celle
        <br />E-Mail:
        <a
          href="mailto:Isa.Kernberger-Fischer@fli.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >Isa.Kernberger-Fischer@fli.de
        </a>
        <br />
        <br />
        <a
          href="https://www.fli.de/de/institute/institut-fuer-tierschutz-und-tierhaltung-itt/forschungsbereiche-arbeitsgruppen/fb-transport/forschungsprojekte-einzelansicht/forschungsprojekt-nationales-tierwohl-monitoring-natimon/"
          target="_blank"
          >Dr. Sally Rauterberg</a
        >
        <br />
        Friedrich-Loeffler-Institut, Celle
        <br />E-Mail:
        <a
          href="mailto:Sally.Rauterberg@fli.de?subject=Weitere Informationen zu Literaturdatenbank Tierwohlindikatoren"
          >Sally.Rauterberg@fli.de</a
        >
      </div>
      <div class="column-zweispaltig img-container-zentriert">
        <img
          src="assets/img/Logo_FLI.png"
          alt="FLI"
          class="img"
          height="107.54px"
          style="float: left"
        />
      </div>
    </div>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
